import React from 'react';
import Link from 'gatsby-link';
import { format } from 'date-fns';
import SEO from '../components/SEO';

export default ({ data, pathContext }) => (
  <article>
    <SEO
      postSEO
      postNode={data.markdownRemark}
      postPath={data.markdownRemark.frontmatter.id}
    />
    <h1>{data.markdownRemark.frontmatter.title}</h1>
    <div dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }} />
    <span className="meta">
      <Link to="/">&larr; Fabian Schultz</Link> &middot;{' '}
      {format(data.markdownRemark.frontmatter.date, 'MMMM D, YYYY')}
    </span>
  </article>
);

export const pageQuery = graphql`
  query PostByPath($absolutePath: String!) {
    markdownRemark(fileAbsolutePath: { eq: $absolutePath }) {
      frontmatter {
        title
        date
        id
      }
      excerpt
      html
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/post.js